<template>
  <div>
    <b-table
      ref="table"
      :fields="dtFields"
      :primary-key="dtFieldsKey"
      :items="dtItemsProvider"
      :per-page="pageSize"
      :current-page="currentPage"
      striped
      outlined
      borderless
      small
      class="pt-3"
      v-bind:show-empty="true"
      responsive="true"
      sidePagination="server"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
    >
      <div slot="table-busy" class="text-center text-primary my-2">
        <b-spinner class="align-middle"></b-spinner>
        <strong>&nbsp; Proszę czekać...</strong>
      </div>
      <template slot="index" slot-scope="data">{{ (currentPage-1) * pageSize + data.index + 1 }}</template>

      <template slot="details" slot-scope="row">
        <font-awesome-icon
          icon="info-circle"
          class="fa-fs row-details-btn action details"
          @click="emit('onDetails', row.item.id)"
          title="Szczegóły"
        ></font-awesome-icon>
      </template>

      <template slot="info" slot-scope="row">
        <font-awesome-icon
          icon="info-circle"
          class="fa-fs row-info-btn action info"
          @click="emit('onInfo', row.item.id)"
          title="Szczegóły"
        ></font-awesome-icon>
      </template>

      <template slot="edit" slot-scope="row">
        <font-awesome-icon
          icon="edit"
          class="fa-fs row-edit-btn action edit"
          @click="emit('onEdit', row.item.id)"
          title="Edytuj"
        ></font-awesome-icon>
      </template>

      <template slot="delete" slot-scope="row">
        <font-awesome-icon
          icon="trash-alt"
          class="fa-fs row-delete-btn action delete"
          @click="emit('onDelete', row.item.id)"
          title="Usuń"
        ></font-awesome-icon>
      </template>

      <template slot="empty">
        <div class="text-center text-primary my-2">
          <strong>Brak danych</strong>
        </div>
      </template>
      <template slot="emptyfiltered">
        <h4>Brak danych</h4>
      </template>

      <template v-for="(_, name) in $scopedSlots" :slot="name" slot-scope="slotData">
        <slot :name="name" v-bind="slotData" />
      </template>
    </b-table>
    <b-row>
      <b-col>
        <b-form-select style="width: min-content;" v-model="pageSize" :options="dtPageSizes"></b-form-select>
      </b-col>
      <b-col>
        <b-pagination
          align="right"
          v-model="currentPage"
          :total-rows="dtItemsTotal"
          :per-page="pageSize"
        ></b-pagination>
      </b-col>
    </b-row>
  </div>
</template>
<script>
export default {
  methods: {
    refresh() {
      this.$refs.table.refresh();
    },
    emit(eventName, id) {
      this.$emit(eventName, id);
    }
  },
  data() {
    return {
      currentPage: this.dtPage,
      pageSize: this.dtPageSize,
      totalRows: this.dtItemsTotal
    };
  },
  props: {
    dtId: String,
    dtFields: Array,
    dtFieldsKey: String,
    dtPageSizes: Array,
    dtPageSize: Number,
    dtPage: Number,
    dtItemsProvider: Function,
    dtItemsTotal: Number,
    sortBy: String,
    sortDesc: String
  }
};
</script>
<style lang="scss" scoped>
</style>
